module.exports = __webpack_public_path__ + "static/media/Association Studios full logo_1709124706776.49e308fb.eps";